import { UnifiedProduct } from '../types/product';
import { CustomerProductPrice } from '../types/productPricing';
import { RelatedProductsData } from '../types/relatedProduct';

export type MergedUnifiedProductsParams = {
  primaryProducts?: UnifiedProduct[];
  pricingData?: CustomerProductPrice[];
  relatedProductsData?: RelatedProductsData[];
};

export const mergeUnifiedPrimaryProductsAndRelatedData = ({
  primaryProducts = [],
  pricingData = [],
  relatedProductsData = [],
}: MergedUnifiedProductsParams): UnifiedProduct[] => {
  if (!primaryProducts?.length) {
    return [];
  }

  // Create lookup maps for O(1) access instead of O(n) find operations
  const pricingMap = new Map(
    pricingData?.map((pricingEntry) => [
      pricingEntry.masterProductId,
      pricingEntry,
    ])
  );

  const relatedProductsMap = new Map(
    relatedProductsData?.map((relatedProducts) => [
      relatedProducts.groupCode,
      relatedProducts,
    ])
  );

  // Single iteration through products with O(1) lookups
  return primaryProducts?.map((primaryProduct) => {
    const masterProductId = primaryProduct?.masterProductId;
    const groupCode = primaryProduct?.groupCode;
    const relatedProductsDataForProduct = relatedProductsMap.get(groupCode);

    return {
      ...primaryProduct,
      pricing: pricingMap.get(masterProductId),
      relatedProductsData: relatedProductsDataForProduct,
      // Only used in tracking for Sets/Bundles. Sourced from the primary
      // product feed (CIO `component_product_id_object_list` or products/v2)
      // since productsByGroupCode does not return swatch siblings for bundles.
      componentProductIdObjectList:
        primaryProduct?.componentProductIdObjectList,
    };
  });
};
